import { CompanySetUpTabHash } from 'enums/CompanySetupEnums';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import COButton from 'shared/components/COButton';
import OrganizationModal from 'shared/components/OrganizationModal';
import useRedirect from 'shared/utils/useRedirect';
import styles from './deleteModal.module.scss';

interface DeleteLocationModalProps {
  isModalOpen: boolean;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  deleteLocation?: (locationId?: number | undefined) => Promise<void>;
  deleteLoading?: boolean;
}

const DeleteLocationModal: FC<DeleteLocationModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  deleteLocation,
  deleteLoading,
}) => {
  const handleClose = () => setIsModalOpen?.(false);
  const { id: locationId } = useParams();

  const { redirectToCompanySetUp } = useRedirect();
  const handleDelete = async () => {
    await deleteLocation?.(Number(locationId));
    setIsModalOpen?.(false);
    redirectToCompanySetUp(CompanySetUpTabHash.LOCATIONS)();
  };
  return (
    <div>
      <OrganizationModal
        visible={isModalOpen}
        onClose={handleClose}
        children={
          <div className={styles.deleteModalContainer}>
            <div className={styles.deleteTitleTextContainer}>
              Deleting this location will remove its data from all the years.
              Are you sure to delete?
            </div>
            <div className={styles.buttonContainer}>
              <COButton
                danger
                loading={deleteLoading}
                children={'Delete'}
                onClick={handleDelete}
              />
              <COButton secondary children={'Cancel'} onClick={handleClose} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default DeleteLocationModal;
